/**
 * The masked men of the 256 m plains' M7 (หน้ากากไม้, docs/design/C0_OPENING_PLAINS.md §11.3): hunters of the marked in
 * dark-brown field wear and a plain mask over the face. All men, so one look each (the chief is taller by his
 * monster scale, with a red sash).
 */
import { LOOKS } from './heroes';

LOOKS.maskedMan = {
  ...LOOKS.bandit!,
  hair: '#1c1814',
  hairH: '#38302a',
  hairStyle: 'topknot',
  headwear: 'band',
  accent: '#3a2c20',
  outer: '#4a3a30',
  outerS: '#2e241e',
  outerH: '#6a5646',
  trim: '#1c1612',
  inner: '#2a2420',
  innerS: '#1a1614',
  sash: '#2a2420',
  sashS: '#14110f',
  boots: '#1a1612',
  bootsS: '#2e2822',
  pelt: undefined,
  mask: '#8a6a44',
  beard: undefined,
  weapon: 'sword',
  blade: '#b4b8c0',
  bladeS: '#5e6470',
};
/** หัวหน้าหน้ากากไม้: the same hunters' dress with a red sash and a darker blade. */
LOOKS.maskedChief = {
  ...LOOKS.maskedMan!,
  sash: '#8a1e22',
  sashS: '#5a1216',
  accent: '#8a1e22',
  trim: '#8a1e22',
  blade: '#8e94a2',
  bladeS: '#2e323c',
};
